import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import { buildQueryParams, buildAffiliateBodyProperties } from '../utils';

export default function checkout(params) {
    const {
        baseUrl,
        brandId,
        country,
        uberToken,
        clientId,
        clientSecret,
        appNameHeaderValue,
        clearMessages = true,
        body = {},
        accessProfile = 'YNAP_PAYMENT_JSON',
        langId,
        additionalHeaders = {},
    } = params;

    invariant(baseUrl, 'baseUrl is a required param of checkout()');
    invariant(brandId, 'brandId is a required param of checkout()');
    invariant(country, 'country is a required param of checkout()');
    invariant(uberToken, 'uberToken is a required param of checkout()');
    invariant(clientId, 'clientId is a required param of checkout()');

    const affiliateProperties = buildAffiliateBodyProperties();
    // will use new access profile for PSD2, keep 'YNAP_PAYMENT_JSON' default as backward compatible
    const query = buildQueryParams({ accessProfile, clearMessages, langId });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart/@self/checkout${query}`;
    const headers = {
        'Content-Type': 'application/json',
        'x-appname': appNameHeaderValue || brandId,
        ...additionalHeaders,
    };

    return labelRequest(
        authenticatedRequest(
            new Request(url, { headers: new Headers(headers), method: 'POST', body: JSON.stringify({ ...body, ...affiliateProperties }) }),
            uberToken,
            clientId,
            clientSecret,
        ),
        'checkout',
    );
}
